<micro-select-combo #sel
              [placeholder]="placeholder"
              routerBase="sqlServerGroups"
              [(id)]="sqlServerGroupId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
